// extracted by mini-css-extract-plugin
module.exports = {"Features":"AboutUsPage_Features__nzkEi"};